// imports section Start
import {
  Box,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemText,
  Grid,
} from "@mui/material";
import React from "react";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../../assets/styles/Theme";
import qr_code from "../../../assets/images/qr_code.png";
// imports section End

function CashReceiptFooterA4({
  billOptions,
  mappedOptions,
  orderPayload,
  qrcode,
}) {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  // Hooks end

  // Handlers start
  const {
    Table1: orderDetails = [], // Rename Table1 to orderSummary
    Table2: itemCharges = [], // Rename Table2 to itemDetails
    Table3: cartItems = [], // Rename Table3 to totals
  } = orderPayload || {};
  // Handlers end
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
      }}
    >
      <Grid container>
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={6}
          xl={6}
          textAlign={"left"}
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"flex-start"}
          alignItems={"flex-start"}
        >
          {mappedOptions.has(19) &&
            orderDetails?.[0]?.FOOTER &&
            Object.keys(orderDetails[0].FOOTER).length > 0 && (
              <Typography
                variant="sub_title"
                align="center"
                mb={1}
                fontWeight={400}
              >
                {JSON.stringify(orderDetails[0].FOOTER)}{" "}
                {/* Convert to string for display */}
              </Typography>
            )}
          {mappedOptions.has(20) && (
            <Typography
              variant="sub_title"
              align="center"
              mb={1}
              fontWeight={400}
            >
              {/* This is for footrlink */}
              {/* {orderDetails?.[0]?.INVNO} */}
            </Typography>
          )}

          {mappedOptions.has(21) &&
            orderDetails?.[0]?.REFPOLICY &&
            Object.keys(orderDetails[0].REFPOLICY).length > 0 && (
              <Typography variant="caption" align="center" fontWeight={600}>
                {JSON.stringify(orderDetails[0].REFPOLICY)}{" "}
                {/* Convert to string for display */}
              </Typography>
            )}
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={6}
          xl={6}
          display={"flex"}
          alignItems={"flex-end"}
          justifyContent={"flex-end"}
        >
          {mappedOptions.has(18) && (
            <Box>
              {qrcode} {/* Render the QR code */}
            </Box>
          )}
        </Grid>
      </Grid>
    </Box>
  );
}

export default CashReceiptFooterA4;
